var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: { model: _vm.form, "label-width": "160px" }
              },
              [
                _c("p", [_vm._v("广州寄件人")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "寄件人" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.gz_sender.name,
                        callback: function($$v) {
                          _vm.$set(_vm.form.gz_sender, "name", $$v)
                        },
                        expression: "form.gz_sender.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "电话" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.gz_sender.phone,
                        callback: function($$v) {
                          _vm.$set(_vm.form.gz_sender, "phone", $$v)
                        },
                        expression: "form.gz_sender.phone"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v("杭州寄件人")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "寄件人" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.hz_sender.name,
                        callback: function($$v) {
                          _vm.$set(_vm.form.hz_sender, "name", $$v)
                        },
                        expression: "form.hz_sender.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "电话" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.hz_sender.phone,
                        callback: function($$v) {
                          _vm.$set(_vm.form.hz_sender, "phone", $$v)
                        },
                        expression: "form.hz_sender.phone"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("el-row")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2660f0d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2660f0d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/WavePickingSetting.vue
// module id = null
// module chunks = 